module.exports = __webpack_public_path__ + "img/img1.cc445d72.png";